/** Screen API — Faz 1.3 createApi factory ile yeniden yazıldı. Önce: 246 satır. */
import {type ApiRequestOpts, createApi} from './_factory'
import type {CommonNs, ScreenNs} from '@shared/types'

const api = createApi('screen')

const updateScreen = (data: ScreenNs.UpdateScreenRequest) =>
  api.post<ScreenNs.UpdateScreenRequest, ScreenNs.Screen>('update-screen', data)

export const ScreenApi = {
  // — Liste —
  getAllScreen: (data: ScreenNs.GetAllScreenRequest) =>
    api.post<ScreenNs.GetAllScreenRequest, ScreenNs.Screen[]>('get-all', data),

  // — Hiyerarşi —
  updateScreenParent: (data: ScreenNs.UpdateScreenParentRequest) =>
    api.post<ScreenNs.UpdateScreenParentRequest, ScreenNs.Screen[]>('update-parent', data),

  // — Box (canvas içi öğe) —
  updateScreenBox: (data: ScreenNs.UpdateScreenRequest) =>
    api.post<ScreenNs.UpdateScreenRequest, ScreenNs.Screen>('update-screen-box', data),
  updateScreenBoxes: (data: ScreenNs.UpdateScreenRequest) =>
    api.post<ScreenNs.UpdateScreenRequest, ScreenNs.Screen>('update-screen-boxes', data),

  // — Tek ekran mutasyonu (kanonik) —
  updateScreen,
  deleteScreen: (data: ScreenNs.UpdateScreenRequest) =>
    api.post<ScreenNs.UpdateScreenRequest, ScreenNs.Screen>('delete-screen', data),
  duplicateScreen: (data: ScreenNs.UpdateScreenRequest) =>
    api.post<ScreenNs.UpdateScreenRequest, ScreenNs.Screen>('duplicate-screen', data),

  // — Grup —
  createAGroup: (data: ScreenNs.UpdateScreenRequest) =>
    api.post<ScreenNs.UpdateScreenRequest, ScreenNs.Screen>('add-screen-group', data),

  // — Screen ↔ Feature ilişkisi —
  getScreenFeatures: (data: ScreenNs.ScreenFeatureRequest) =>
    api.post<ScreenNs.ScreenFeatureRequest, CommonNs.AnyResponse>('get-screen-feature', data),
  addScreenFeatures: (data: ScreenNs.ScreenFeatureRequest) =>
    api.post<ScreenNs.ScreenFeatureRequest, ScreenNs.Screen>('add-screen-feature', data),
  updateScreenFeatures: (data: ScreenNs.ScreenFeatureRequest) =>
    api.post<ScreenNs.ScreenFeatureRequest, CommonNs.AnyResponse>('update-screen-feature', data),
  removeScreenFeatures: (data: ScreenNs.ScreenFeatureRequest) =>
    api.post<ScreenNs.ScreenFeatureRequest, ScreenNs.Screen>('remove-screen-feature', data),

  // — Upload (multipart) —
  uploadScreen: (data: FormData, opts?: ApiRequestOpts) =>
    api.upload<ScreenNs.Screen>('add-screen', data, opts),
  replaceScreen: (data: FormData, opts?: ApiRequestOpts) =>
    api.upload<ScreenNs.Screen>('replace-screen', data, opts),

  // — Image'siz ekran ekleme —
  createScreenWithoutImage: (data: unknown) =>
    api.post<unknown, ScreenNs.Screen>('add-screen', data),
  createScreenPlaceholder: (data: unknown) =>
    api.post<unknown, ScreenNs.Screen[]>('add-screen-placeholder', data),

  // — Versiyon —
  setCurrentVersion: (data: ScreenNs.SetCurrentVersionRequest) =>
    api.post<ScreenNs.SetCurrentVersionRequest, ScreenNs.Screen>('set-current-version', data),
  deleteVersion: (data: ScreenNs.DeleteVersionRequest) =>
    api.post<ScreenNs.DeleteVersionRequest, ScreenNs.Screen>('delete-version', data),

  // — Lakap alias'lar (deprecated, Faz 4'te silinecek) —
  updateShowOrHide: updateScreen,
  /** @deprecated `updateScreen` ile aynı endpoint. */
  renameScreen: updateScreen,
  /** @deprecated `updateScreen` ile aynı endpoint. */
  changeScreenColor: updateScreen,
}
